import React from 'react';
import { Button, Modal } from 'flowbite-react';
import useDisclosure from 'src/hooks/utils/useDisclosure';
import { RxCross2 } from 'react-icons/rx';

interface Props {
	isOpen: boolean;
	onClose: () => void;
}

const CancelInterviewModal = ({ isOpen, onClose }: Props) => {
	return (
		<div>
			<Modal position={'center'} show={isOpen} dismissible={true} onClose={onClose} size={'md'}>
				<Modal.Body className="relative flex flex-col gap-y-8 justify-center rounded-[8px] border border-solid border-[#555770] bg-[#1F2A37] p-8">
					<div>
						<p className="text-center text-[#F2F2F5] font-inter text-[16px] font-[500] leading-[24px]">
							Are you sure you want to reschedule the interview?
						</p>
						<div className="mt-[20px] flex items-center gap-[16px] justify-center">
							<Button color="purplePlaced" onClick={() => {}}>
								Yes, I’m sure
							</Button>
							<Button
								onClick={() => {
									onClose();
								}}
								className="!bg-[#4B5563] hover:!bg-[#566171] !border !border-[#6B7280] text-[#9CA3AF]"
							>
								No, Cancel
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={onClose}
						className="absolute right-[10px] top-[10px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
					/>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default CancelInterviewModal;
